import { inject } from '@angular/core';
import { Route } from '@angular/router';

import { provideHttpMock } from '@kros-sk/core/http-mock';
import { KrosAuthService } from '@kros-sk/auth';
import { ModuleShellComponent } from '@kros-sk/office/module-shell';
import { addSchemaComponentToRegistry, provideSchemaComponents } from '@kros-sk/core/schema';
import {
  PUBLIC_DOCUMENT_MODULES_URL,
  PUBLIC_DOCUMENT_SUBMODULE_URL,
  PUBLIC_DOCUMENT_SUBMODULES_URL,
  PublicDocumentModulesMockService,
  PublicDocumentSubmoduleMockService,
  PublicDocumentSubmodulesMockService,
} from '@kros-sk/document-viewer/mocks';
import { PageNotFoundComponent } from '@kros-sk/shared-esw/page-not-found';
import { DOCUMENT_PDF_TELEMETRY } from '@kros-sk/shared-esw/document-view';
import { provideUrlModals } from '@kros-sk/shared/modal-sheet';
import { DocumentViewTelemetryService, visitedPath } from '@kros-sk/document-viewer/public-document-view';
import { provideApplicationModules } from '@kros-sk/application-modules';
import { provideApplicationSubmodules } from '@kros-sk/application-submodules';

import { viewDocumentResponseResolver } from './routes/view-document.resolver';

export const routes: Route[] = [
  {
    path: 'oidc/login-redirect',
    redirectTo: async (): Promise<string> => {
      await inject(KrosAuthService).manager.signinCallback().catch((error) => console.error(error));
      return visitedPath() ?? '/not-found';
    },
  },
  {
    path: 'oidc/logout-redirect',
    redirectTo: () => visitedPath() ?? '/not-found',
  },
  {
    path: ':module/:detailId',
    loadComponent: () => import('@kros-sk/document-viewer/public-shell').then((l) => l.PublicShellComponent),
    resolve: viewDocumentResponseResolver(),
    providers: [
      provideApplicationModules({ apiUrl: PUBLIC_DOCUMENT_MODULES_URL }),
      provideApplicationSubmodules({
        apiUrlSubmodules: PUBLIC_DOCUMENT_SUBMODULES_URL,
        apiUrlSubmodule: PUBLIC_DOCUMENT_SUBMODULE_URL,
      }),
      provideHttpMock(PublicDocumentModulesMockService, PublicDocumentSubmodulesMockService, PublicDocumentSubmoduleMockService),
      // The eFaktúra XML viewer of the document tile is a schema modal, opened and closed through the URL.
      provideUrlModals(),
      provideSchemaComponents(
        addSchemaComponentToRegistry('public-document', () => import('@kros-sk/dashboard/ui').then((m) => m.DashboardPageComponent))
      ),
      // The registry builds the `document-pdf` data source under this route's injector; a token on the shell never reaches it.
      { provide: DOCUMENT_PDF_TELEMETRY, useExisting: DocumentViewTelemetryService },
    ],
    children: [
      {
        path: '',
        component: ModuleShellComponent,
      },
    ],
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
